import React, { Component } from 'react';

import Loading from '../components/Loading';
import OAuthError from './OAuthError';

import api from '../util/api';

const clientIds = {
    blizzard: {
        us: 'fa9b33c953d549c58b028e3e588f533e',
        eu: 'e9332d2f25554b959db636ad0bdd3ba8',
        kr: '2988c38da1c84c5d863f5f3fb353dce0',
        tw: '6d2077e92c6a48628d2de41b1cd50aaa'
    },
    patreon: 'gr7cvE6qR49wbH_xp6oUiKfSb1IhdED9cb1Wc6VDvZ82HZuwogORfh5-T17mxgjg',
    twitch: 'ffd4lf57uy229os2p5ybszs74c2dlu'
};

export default class OAuth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    componentDidMount() {
        this.redirect();
    }

    componentDidUpdate(previous) {
        if (previous.state === this.props.state && previous.to === this.props.to && previous.from === this.props.from) return;
        this.redirect();
    }

    async redirect() {
        try {
            if (this.props.to) {
                await this.outgoing();
            } else if (this.props.state) {
                await this.incoming();
            }
        } catch(e) {
            this.setState({ error: true });
            // console.error(e);
        }
    }

    async outgoing() {
        const stage = (window.location.hostname === 'dev.dataforazeroth.com') ? 'https://dev.dataforazeroth.com/redirect' : 'https://www.dataforazeroth.com/redirect';

        if (this.props.to === 'blizzard') {
            const region = this.props.region;
            const state = 'blizzard' + region + Date.now().toString(36).slice(-5);
            localStorage.setItem('state.blizzard', JSON.stringify({ state, from: this.props.from }));

            const url = 'https://oauth.battle.net/oauth/authorize?client_id=' + encodeURIComponent(clientIds.blizzard[region]) + '&scope=wow.profile&state=' + encodeURIComponent(state) + '&redirect_uri=' + encodeURIComponent(stage) + '&response_type=code';
            document.location.href = url;
        } else if (this.props.to === 'patreon') {
            const state = 'patreon' + Date.now().toString(36).slice(-5);
            localStorage.setItem('state.patreon', JSON.stringify({ state, from: this.props.from }));

            const url = 'https://www.patreon.com/oauth2/authorize?response_type=code&client_id=' + encodeURIComponent(clientIds.patreon) + '&redirect_uri=' + encodeURIComponent(stage) + '&state=' + encodeURIComponent(state);
            document.location.href = url;
        } else if (this.props.to === 'twitch') {
            const state = 'twitch' + Date.now().toString(36).slice(-5);
            localStorage.setItem('state.twitch', JSON.stringify({ state, from: this.props.from }));

            let url = 'https://id.twitch.tv/oauth2/authorize?response_type=code&client_id=' + encodeURIComponent(clientIds.twitch) + '&redirect_uri=' + encodeURIComponent(stage) + '&state=' + encodeURIComponent(state);
            if (this.props.with === 'scope') {
                url += '&scope=channel:read:subscriptions';
            }
            document.location.href = url;
        }
    }

    verifyState = (key, expected) => {
        const state = JSON.parse(localStorage.getItem(key));
        localStorage.removeItem(key);

        if (expected !== state.state) throw new Error('Invalid state');
        return state;
    }

    async incoming() {
        if (this.props.state.startsWith('blizzard')) {
            const state = this.verifyState('state.blizzard', this.props.state);

            const region = this.props.state.substring(8, 10);
            const response = this.props.code && await api.get('token/blizzard/' + encodeURIComponent(region) + '/' + encodeURIComponent(this.props.code));
            const json = await response.json();
            if (!json.access_token) throw new Error('Invalid Token');

            localStorage.setItem('token.blizzard', JSON.stringify(json));
            this.props.history.push(state.from);
        } else if (this.props.state.startsWith('patreon')) {
            const state = this.verifyState('state.patreon', this.props.state);

            const response = this.props.code && await api.get('token/patreon/' + encodeURIComponent(this.props.code));
            const json = await response.json();
            if (!json.access_token) throw new Error('Invalid Token');

            localStorage.setItem('token.patreon', JSON.stringify(json));
            this.props.history.push(state.from);
        } else if (this.props.state.startsWith('twitch')) {
            const state = this.verifyState('state.twitch', this.props.state);

            const response = this.props.code && await api.get('token/twitch/' + encodeURIComponent(this.props.code));
            const json = await response.json();
            if (!json.access_token) throw new Error('Invalid Token');

            localStorage.setItem('token.twitch', JSON.stringify(json));
            this.props.history.push(state.from);
        }
    }

    render() {
        return this.state.error ? <OAuthError /> : <Loading message="Loading..." />;
    }
}